import { LanguageNameSpaces, OrderTypes, TriggerType } from "@shared/types";
import {
  getItemByName,
  getOptions,
} from "@shared/features/configuration/utils";
import { TRAILING_STOP_TYPE_ITEM_NAME } from "@shared/features/configuration/constants";
import { findNameByValue } from "@shared/features/tradingTerminal/common/utils";
import { TRIGGER_TYPE_TO_DISPLAY_NAME } from "@shared/features/tradingTerminal/common/constants";
import { TradingTerminalContext } from "@shared/features/tradingTerminal/TradingTerminal.context";
import { useContext } from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

const useTrailingSummaryRow = () => {
  const {
    trailingEntry,
    trailingTakeProfit,
    trailingStop,
    useTrailing,
    getCreateGeneralDataQuery,
    isSignal,
  } = useContext(TradingTerminalContext)!;
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADING_TERMINAL);
  const item = getCreateGeneralDataQuery.data?.data.configuration;

  const trailing = {
    [OrderTypes.ENTRY]: trailingEntry,
    [OrderTypes.TAKE_PROFIT]: trailingTakeProfit,
    [OrderTypes.STOP]: trailingStop,
  };

  const trailingTypeItem = getItemByName(TRAILING_STOP_TYPE_ITEM_NAME, item);
  const triggerValuePrefix =
    trailingStop?.trigger.type === TriggerType.TARGET ? "#" : "%";

  const trailingStopDisplayData = {
    type: findNameByValue(getOptions(trailingTypeItem), trailingStop?.type),
    value: trailingStop?.value && `, %${trailingStop?.value}`,
    triggerType: t(
      TRIGGER_TYPE_TO_DISPLAY_NAME[
        (trailingStop?.trigger.type || TriggerType.TARGET) as TriggerType
      ]
    ),
    triggerValue:
      trailingStop?.trigger?.value === 0
        ? t("labels.entry_fill")
        : `${triggerValuePrefix}${trailingStop?.trigger.value}`,
  };

  return {
    trailing,
    useTrailing,
    trailingStopDisplayData,
    isSignal,
  };
};

export default useTrailingSummaryRow;
